import { useContext } from 'react';

import { ModalContext } from './ModalContext';

const useModal = () => {
  const ctx = useContext(ModalContext);

  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (!ctx) throw new Error('⚠️ useModal was called outside of <MyContext.Provider>.');

  return ctx;
};

export { useModal };
